export default __webpack_public_path__ + "navigation-examples-waypoint-arrival-screen-thumbnail-960-6e0df0981429db34f808aa06dd6fdf28.png";